import { render } from "./NotFound.vue?vue&type=template&id=2171f724"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/routes/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2171f724"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2171f724', __exports__)) {
    api.reload('2171f724', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=2171f724", () => {
    api.rerender('2171f724', render)
  })

}


export default __exports__